<div class="content-box">

  <div class="left">
    <ng-content></ng-content>
  </div>

  <div class="right">
    <img [src]="imgSrc" [ngClass]="{'desktop-view': imgSrcMobile}" alt="tab" />
    <img *ngIf="imgSrcMobile" [src]="imgSrcMobile" class="mobile-view" src="" alt="">
  </div>

</div>
